import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, computed } from 'vue'
import VPaidIcon from '@/components/paid-icon.vue'
import { DataInstance } from '@busy-human/gearbox';
import { InviteLinks } from '@busy-human/opt-library';

type Props = {
    invite: DataInstance<InviteLinks.Model>
}
type Emits = {
    (e: 'openPopup', value:DataInstance<InviteLinks.Model>):void
    (e: 'openSharePopup', value:DataInstance<InviteLinks.Model>):void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'invite-link',
  props: {
    invite: null
  },
  emits: ["openPopup", "openSharePopup"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'openPopup', value:DataInstance<InviteLinks.Model>):void
    (e: 'openSharePopup', value:DataInstance<InviteLinks.Model>):void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    invite: DataInstance<InviteLinks.Model>
}





const linkActive = ref(props.invite.active)
const linkName = ref(props.invite.name)

watch(()=>props.invite, ()=>{
    linkActive.value = props.invite.active
    linkName.value = props.invite.name
})

const meetingURL = computed(() => `${window.location.protocol}//${window.location.host}/#/invite/${props.invite?.link}`)

const handleClick = () =>{
    // console.log("here", props.invite)
    emit('openPopup', props.invite)
}

const handleShareClick = () =>{
    // console.log("here", props.invite)
    emit('openSharePopup', props.invite)
}

const __returned__ = { props, emit, linkActive, linkName, meetingURL, handleClick, handleShareClick, ref, watch, computed, VPaidIcon, DataInstance, InviteLinks }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})